import { EnvironmentType } from '@/configs/environments/types'

import { config as developmentConfig } from './environments/development'
import { config as localConfig } from './environments/local'
import { config as productionConfig } from './environments/production'
import { config as stageConfig } from './environments/stage'

const environment = process.env.SERVICE_ENV || 'development'
console.log('environment:', environment)

const CONFIG_MAP: Record<string, EnvironmentType> = {
  local: localConfig,
  development: developmentConfig,
  stage: stageConfig,
  production: productionConfig
}

const getConfig = async (): Promise<EnvironmentType> => {
  return CONFIG_MAP[environment] ?? developmentConfig
}

export { getConfig }
